/* eslint-disable react/forbid-prop-types */
import React from "react";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import { useRouteMatch, useParams, Link } from "react-router-dom";
import TriggerBox from "./TriggerBox";
import TriggerLoader from "./TriggerLoader";
import AddTrigger from "./AddTrigger";
import EditTriggerEmail from "./EditTriggerEmail";
import communicationTriggers from "../../utils/communicationTriggers";
import BackArrow from "../../assets/img/icons/icon-arrow-east.svg";
import * as communicationActions from "../../redux/actions/communicationActions";

const mapDispatchToProps = {
  ...communicationActions,
};

const mapStateToProps = (state) => {
  const { workflows } = state;
  return {
    stateWorkflow: workflows,
  };
};

function TriggerPanel({
  fetchWorkflow,
  addWorkflowStep,
  stateWorkflow,
  fetchTriggers,
  setActiveWorkFlow,
  setSidePanel,
}) {
  const { path } = useRouteMatch("/communications");
  const url = `${path}/automatic/`;
  const { event } = useParams();

  React.useEffect(() => {
    fetchTriggers();
    fetchWorkflow(event);
  }, [fetchTriggers, fetchWorkflow, event]);

  const [eventTrigger, setEventTrigger] = React.useState(null);

  const hideSidePanelClick = React.useCallback(() => {
    setSidePanel(false);
  }, [setSidePanel]);

  const eventWorkFlow = stateWorkflow[event];

  const showSidePanelClick = React.useCallback(
    (blockId) => {
      const block = eventWorkFlow.blocks.find((b) => b.id === blockId);
      setSidePanel(true);
      setActiveWorkFlow(block.id);
    },
    [eventWorkFlow, setActiveWorkFlow, setSidePanel],
  );

  const data = React.useMemo(() => communicationTriggers, []);

  React.useEffect(() => {
    const trigger = data.find((d) => d.activityEventName === event);

    setEventTrigger(trigger);
  }, [eventTrigger, setEventTrigger, data, event]);

  const triggers = useSelector((state) => state.communications.data);

  const trigger = triggers.find((t) => t.activityEventName === event);

  if (!trigger) return <TriggerLoader />;

  const { activeWorkflowId, showSidePanel } = stateWorkflow;

  if (!eventTrigger || !eventWorkFlow) return <TriggerLoader />;

  return (
    <div>
      <div className="pp_trigger_back">
        <Link to={url}>
          <BackArrow className="pp_comms_back_arrow" />
          All Triggers
        </Link>
      </div>
      <div className="pp_trigger_holder">
        <div className="pp_trigger_header">
          <div className="pp_trigger_name">{eventTrigger.shortDescription}</div>
          <div className="pp_trigger_hint">Will trigger when :</div>
          <div className="pp_trigger_detail">
            {eventTrigger.longDescription}
          </div>
        </div>
      </div>
      <div className="pp_trigger_break_element">Message</div>
      {eventWorkFlow.blocks.map((block) => {
        return (
          <TriggerBox
            key={block.id}
            blockId={block.id}
            triggertype={block.type}
            receipients={block.to}
            showPanelClick={showSidePanelClick}
          />
        );
      })}
      <AddTrigger event={event} addWorkflowStep={addWorkflowStep} />
      {showSidePanel && activeWorkflowId && (
        <EditTriggerEmail
          show={showSidePanel}
          event={event}
          hidePanelClick={hideSidePanelClick}
        />
      )}
    </div>
  );
}

TriggerPanel.propTypes = {
  fetchWorkflow: PropTypes.func.isRequired,
  addWorkflowStep: PropTypes.func.isRequired,
  fetchTriggers: PropTypes.func.isRequired,
  setActiveWorkFlow: PropTypes.func.isRequired,
  setSidePanel: PropTypes.func.isRequired,
  stateWorkflow: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(TriggerPanel);
